module.exports = __webpack_public_path__ + "media/images/hero/glyph-c2-c80d81a22ad3878442fbaa2c0f03441b.svg";